import request from '@/axios';

export const dimensionTree = (params) => {
  return request({
    url: '/emp-business/dimensionSet/tree',
    method: 'get',
    params,
  });
};


export const energylDimensionDetail = (params) => {
  return request({
    url: '/emp-business/energyDimens/detailDimension',
    method: 'get',
    params,
  });
};

export const getDimensionTree = (params) => {
  return request({
    url: '/emp-business/energyDimens/tree',
    method: 'get',
    params,
  });
};
export const getEnvironmentDimensionTree = (params) => {
  return request({
    url: '/emp-business/emi/emiDev/emiTree',
    method: 'get',
    params,
  });
};

export const detailDimension = (params) => {
  return request({
    url: '/emp-business/dimensionSet/detailDimension',
    method: 'get',
    params,
  });
};

export const saveDimensionNode = (data) => {
  return request({
    url: '/emp-business/dimensionSet/saveNode',
    method: 'post',
    data,
  });
};

export const dimensionLinkDevice = (params) => {
  return request({
    url: '/emp-business/dimensionSet/linkDev',
    method: 'get',
    params
  });
};

export const dimensionUnLinkDevice = (params) => {
  return request({
    url: '/emp-business/dimensionSet/unlinkDev',
    method: 'get',
    params
  });
};



export const updateDimensionNode = (data) => {
  return request({
    url: '/emp-business/dimensionSet/updateNode',
    method: 'post',
    data,
  });
};

export const moveDimensionNode = (params) => {
  return request({
    url: '/emp-business/dimensionSet/moveNode',
    method: 'get',
    params,
  });
};

export const deleteDimensionNode = (params) => {
  return request({
    url: '/emp-business/dimensionSet/deleteNode',
    method: 'get',
    params,
  });
};

export const saveEnergyDimensionInfo = (data) => {
  return request({
    url: '/emp-business/energyDimens/saveEnergyDimensionInfo',
    method: 'post',
    data,
  });
};
export const updateEnergyDimensionInfo = (data) => {
  return request({
    url: '/emp-business/energyDimens/updateEnergyDimensionInfo',
    method: 'post',
    data,
  });
};
export const anlysisDimensionTree = (data) => {
  return request({
    url: '/emp-business/energyDimens/anlysis',
    method: 'post',
    data,
  });
};

export const historyDataDimensionTree = (params) => {
  return request({
    url: '/emp-business/historyDataDimension/dimensionTree',
    method: 'get',
    params,
  });
};

export const getHistoryDataDimensionData = (data) => {
  return request({
    url: '/emp-business/historyDataDimension/historyData',
    method: 'post',
    data,
  });
};

export const saveEnvironmentInfo = (data) => {
  return request({
    url: '/emp-business/emi/emiDev/saveEmiDimensionInfo',
    method: 'post',
    data,
  });
};
export const updateEnvironmentInfo = (data) => {
  return request({
    url: '/emp-business/emi/emiDev/updateEmiDimensionInfo',
    method: 'post',
    data,
  });
};

export const detailEnvironmentDimension = (params) => {
  return request({
    url: '/emp-business/emi/emiDev/detailDimension',
    method: 'get',
    params,
  });
};

export const savePvStationDimensionInfo = (data) => {
  return request({
    url: '/emp-business/pvms/pvmsStation/saveStationInfo',
    method: 'post',
    data,
  });
};
export const updatePvStationDimensionInfo = (data) => {
  return request({
    url: '/emp-business/pvms/pvmsStation/updateStationInfo',
    method: 'post',
    data,
  });
};
export const savePvInverterDimensionInfo = (data) => {
  return request({
    url: '/emp-business/pvms/pvmsStation/saveInverter',
    method: 'post',
    data,
  });
};
export const updatePvInverterDimensionInfo = (data) => {
  return request({
    url: '/emp-business/pvms/pvmsStation/updateInverter',
    method: 'post',
    data,
  });
};

export const stationDimensionDetail = (params) => {
  return request({
    url: '/emp-business/pvms/pvmsStation/stationDetail',
    method: 'get',
    params,
  });
};

export const inverterDimensionDetail = (params) => {
  return request({
    url: '/emp-business/pvms/pvmsStation/inverterDetail',
    method: 'get',
    params,
  });
};